import { render } from "./AbilityList.vue?vue&type=template&id=eba2ada0"
import script from "./AbilityList.vue?vue&type=script&lang=js"
export * from "./AbilityList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__